import React, { Component } from 'react';
import Key from '../Key';
import {testKeyFromArr} from '../Key';

var keys = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'W',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  '-',
];

var Keyboard = React.createClass({

  handleClick: function(data){
    var inputText = this.props.text,
        nOne = inputText.search(/\*|_/),
        result = '';

    console.log(inputText[nOne] == '_');
    console.log(/[a-zA-Z]/.test(data));

    if(inputText[nOne] == '*' && /\d/.test(data)){
      result = inputText.replace( /\*/, data);
    }else if(inputText[nOne] == '_' && /[a-zA-Z]/.test(data)){
      console.log('_');
      result = inputText.replace( /_/, data);
    }else{
      return;
    }

    if(this.props.regexp.test(result) && this.props.autoNext){
      this.props.actionDoneNext(result);
      return;
    }

    this.props.actionSaveField(result)
  },
  handleErase: function(){
    console.log('erase');
    var inputText = this.props.text,
        result = '',
        arr = [];

    console.log('this.props.defaultText', this.props.defaultText);
    console.log('inputText', inputText);

    if(this.props.defaultText != inputText){
      inputText.replace(/\d|[A-Z]/gi, function(str, offset, s){
        arr[arr.length] = offset;
      });

      var pos = arr[arr.length - 1];

      if(/\d/.test(inputText[pos])){
        result = inputText.substr(0, pos) + '*' + inputText.substr(++pos);
      }else{
        console.log('_');
        result = inputText.substr(0, pos) + '_' + inputText.substr(++pos);
      }

      this.props.actionSaveField(result)
    }
  },
  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(nextProps.opperativeKey) !== JSON.stringify(this.props.opperativeKey)) {
      if(nextProps.opperativeKey.keyCode == '8'){
        this.handleErase();
        return;
      }
      if(typeof nextProps.opperativeKey.key != 'undefined'){
        if(testKeyFromArr(nextProps.opperativeKey.key, keys)){
          this.handleClick(nextProps.opperativeKey.key)
        }else{
          console.log('не прошел тест', nextProps.opperativeKey)
        }
      }
      
    }
  },
  render: function(){
    if(!this.props.mobile){
      return(
        <div className="keyboardWrapper">
          <div className="Keyboard letters">
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="A" />
            <Key actionClickButton={this.handleClick} val="B" />
            <Key actionClickButton={this.handleClick} val="C" />
            <Key actionClickButton={this.handleClick} val="D" />
            <Key actionClickButton={this.handleClick} val="E" />
            <Key actionClickButton={this.handleClick} val="F" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="G" />
            <Key actionClickButton={this.handleClick} val="H" />
            <Key actionClickButton={this.handleClick} val="I" />
            <Key actionClickButton={this.handleClick} val="J" />
            <Key actionClickButton={this.handleClick} val="W" />
            <Key actionClickButton={this.handleClick} val="1" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="2" />
            <Key actionClickButton={this.handleClick} val="3" />
            <Key actionClickButton={this.handleClick} val="4" />
            <Key actionClickButton={this.handleClick} val="5" />
            <Key actionClickButton={this.handleClick} val="6" />
            <Key actionClickButton={this.handleClick} val="0" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="7" />
            <Key actionClickButton={this.handleClick} val="8" />
            <Key actionClickButton={this.handleClick} val="9" />
            <Key actionClickButton={this.handleClick} val="-" />
            <div className="button next" style={{width: 192}} onClick={this.handleErase}>Стереть</div>
            
          </div>
        </div>
      );
    }else{
      // return(
      //   <div className="keyboardWrapper Numbers">
      //     <div className="Keyboard numbers">
      //       <div className="row">
      //         <div className="innerTable">
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="1" />
      //             <Key actionClickButton={this.handleClick} val="2" />
      //             <Key actionClickButton={this.handleClick} val="3" />
      //             <Key actionClickButton={this.handleClick} val="4" />
      //             <Key actionClickButton={this.handleClick} val="5" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="6" />
      //             <Key actionClickButton={this.handleClick} val="7" />
      //             <Key actionClickButton={this.handleClick} val="8" />
      //             <Key actionClickButton={this.handleClick} val="9" />
      //             <Key actionClickButton={this.handleClick} val="0" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="A" />
      //             <Key actionClickButton={this.handleClick} val="B" />
      //             <Key actionClickButton={this.handleClick} val="C" />
      //             <Key actionClickButton={this.handleClick} val="D" />
      //             <Key actionClickButton={this.handleClick} val="E" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="F" />
      //             <Key actionClickButton={this.handleClick} val="G" />
      //             <Key actionClickButton={this.handleClick} val="H" />
      //             <Key actionClickButton={this.handleClick} val="I" />
      //             <Key actionClickButton={this.handleClick} val="J" />
      //           </div>
      //         </div>
      //       </div>
      //       <div className="row" style={{height: "19.6%"}}>
      //         <div className="innerTable">
      //           <Key actionClickButton={this.handleClick} className="serviceClass serviceClass2" style={{width: "19.5%"}} val="W" />
      //           <div className="serviceClass button" onClick={this.handleErase}>Стереть</div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // );
      return null
    }

  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/NumbersAndLettersLat/index.jsx
 **/